import PropTypes from "prop-types";
import { Divider, Form } from "antd";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { updatePageStepToFinish } from "../../../../../actions/globalActions";
import AlertBox from "../../../../../CommonComponents/AlertBox";
import { DisplayFlex, Spinner } from "../../../../../CommonComponents/commonStyles";
import { flushZipCode, resetAllZipFields, resetZipCode } from "../../../../../CommonComponents/Zipcode/actions";
import history from "../../../../../history/history";
import globalRegex from "../../../../../utils/regexMap";
import { getAccountData, getPrimaryAccount, isGeminiUser } from "../../../../../utils/sessionUtil";
import {
  clearEditProfileError,
  disableButton,
  handleResetFormAddress,
  handleResetFormEmail,
  handleResetFormInfo,
  handleResetFormPhone,
  jsonTemp,
  onEmailChangeHandler,
  onPhoneChangeHandler,
  postProfile,
  reset,
  step1Edit
} from "../../../actions";
import { handleDisabled, recordError } from "../../../../../utils/commonUtil";
import AddressForm from "../../Step1Setup/Components/AddressForm";
import DeliveryMethod from "../../Step1Setup/Components/DeliveryMethod";
import EmailForm from "../../../../../CommonComponents/Forms/EmailInputForm";
import PhoneForm from "../../../../../CommonComponents/Forms/PhoneInputForm";
import { DividerWrap } from "../../Step1Setup/Components/RelatedContributor/styles";
import UserInfoForm from "../../Step1Setup/Components/UserInfoForm";
import {
  AdvisoryFormWrapper,
  DisplayFlexSpaceMobile,
  FormContainer,
  GhostButton,
  GhostButtonReset,
  PrimaryButtonComponentNext,
  RowWrapper
} from "../../Step1Setup/styles";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";
let isNewSecondaryAdvisor = false;

class ProfileForm extends React.Component {
  
  constructor(props) {
    super(props);
    this.phoneFormRef = React.createRef();
    this.emailFormRef = React.createRef();
    this.state = {
      show: false,
      type: "",
      reset: false,
      enableReset: false,
      isUserInfo: false,
      isEmailInfo: false,
      isPhoneInfo: false,
      isAddressInfo: false,
      isSubmit:false,
  
    };

    this.geminiUser = isGeminiUser();

    this.resetPopupContent = {
      heading: "Reset Information",
      line1: "<p>Resetting will delete all entered information on the page</p><p>Do you want to continue?</p>",
      continue: "continue",
      cancel: "No, take me back"
    };

    this.removePopupContent = {
      heading: "Remove secondary advisor",
      line1: "<p>Are you sure you want to remove the secondary advisor?</p><p>Do you want to continue?</p>",
      continue: "continue",
      cancel: "No, take me back"
    };

    this.exitPopupContent = {
      heading: "Cancel",
      line1: "<p>Cancelling will remove all updates.</p><p>Do you want to continue?</p>",
      line2: "Do you want to continue?",
      continue: "continue",
      cancel: "No, take me back"
    };
  }
  advisorType = "Primary"; 


  handleEditReset = () => {
    this.setState({
      show: false,
      type: "reset",
      reset: true
    });
    let postData = {
      fundName: this.props.accountName,
      userId: this.props.webAccessInfo.userId,
      referralCode: {
        referralCodeValue: "",
        comment: ""
      },
      advisors: [
        {
          primary: true,
          title: this.props.primaryAdvisor.info.title,
          firstname: this.props.primaryAdvisor.info.firstname,
          middlename: this.props.primaryAdvisor.info.middlename,
          lastname: this.props.primaryAdvisor.info.lastname,
          suffix: this.props.primaryAdvisor.info.suffix,
          gender: this.props.primaryAdvisor.info.gender,
          dob: this.props.primaryAdvisor.info.dob,
          ssn: this.props.primaryAdvisor.info.ssn,
          phones: this.props.primaryAdvisor.phone.phone,
          emails: this.props.primaryAdvisor.email.email,
          addresses: this.props.primaryAdvisor.addresses.addresses,
          deliveryMethod: this.props.primaryAdvisor.info.deliveryMethod,
          relatedDonor: this.props.primaryAdvisor.relatedDonor.relatedDonor
            ? this.props.primaryAdvisor.relatedDonor.relatedDonor
            : []
        }
      ]
    };
    this.props.jsonTemp({
      tempJSON: postData
    });
  };

  handleReset = advisorType => {
    this.props.resetAllZipCode();
    this.setState({
      show: !this.state.show
    });
    this.props.reset({
      [advisorType]: {
        reset: true
      }
    });
    window.scrollTo(0, 0);
    let emailArr = [];
    let phoneArr = [];
    let addrArr = [];
    let relContr = [];

    emailArr.push({ emailtype: "", emailId: "", key: 1, primary: true });
    phoneArr.push({ phonetype: "", phonenumber: "", key: 1, primary: true });
    addrArr.push({
      addresstype: "",
      line1: "",
      line2: "",
      line3: "",
      zipcode: "",
      city: "",
      state: "",
      country: "0",
      primary: true,
      key: 1
    });
    relContr.push({ name: "", relationship: "", key: 0 });

    this.props.handleResetFormEmail({
      [advisorType]: {
        email: emailArr
      }
    });

    this.setState({
      isUserInfo: true,
      isAddressInfo: true
    },()=>{
      const {resetFields:phoneReset }  = this.phoneFormRef.current.form;
      const {resetFields:emailReset }  = this.emailFormRef.current.form;
        phoneReset();
        emailReset();
    });

    this.props.handleResetFormPhone({
      [advisorType]: {
        phone: phoneArr
      }
    });

    this.props.handleResetFormAddress({
      [advisorType]: {
        addresses: addrArr
      }
    });

    this.props.handleResetFormAddress({
      ["secondaryAdvisor"]: {
        addresses: addrArr
      }
    });
  };

  handleResetSecondary = advisorType => {
    this.handleReset(advisorType);
    window.scrollTo(0, 0);
    this.props.handleResetFormInfo({
      [advisorType]: {}
    });
  };

  enableResetButton = () => {
    this.setState({
      enableReset: true
    });
  };

  finalProfileData = (storeData, primary) => {
    
    let profileInfo = {};
    const userData = getAccountData();
    profileInfo.primaryAccountContact = null;
    profileInfo.accountId = getPrimaryAccount().userId;
    profileInfo.name = null;
    profileInfo.phone = null;
    profileInfo.email = null;
    profileInfo.address = null;
    profileInfo.primary = primary;
    let titleObj = null;
    let suffixObj = null;
    if(storeData.info.title != -1)
    {
   titleObj =  this.props.dropdownValues.title.find(({value}) => {
      return(value === storeData.info.title)
    });
   }

    profileInfo.title = titleObj?.desc||null;
    if (storeData.info.firstname) {
      profileInfo.firstName = storeData.info.firstname;
    } else {
      profileInfo.firstName = null;
    }
    profileInfo.middleName = storeData.info.middlename;
    if (storeData.info.lastname) {
      profileInfo.lastName = storeData.info.lastname;
    } else {
      profileInfo.lastName = null;
    }

    if(storeData.info.suffix != -1)
    {
    suffixObj = this.props.dropdownValues.suffix.find(({value})=>{
      return value ==  storeData.info.suffix;
    })
  }
    profileInfo.suffix = suffixObj?.desc||null;
    profileInfo.gender = storeData.info.gender;
    profileInfo.partyId = userData.partyId;
    profileInfo.dob = storeData.info.dob
      ? moment(storeData.info.dob, "MM/DD/YYYY")
          .valueOf()
          .toString()
      : null;
    profileInfo.dateOfBirthStr = storeData.info.dob ? moment(storeData.info.dob).format("MM/DD/YYYY") : null;
    if (primary === true) {
      let relatedDonor = storeData.relatedDonor.relatedDonor;
      profileInfo.relatedDonor = relatedDonor;
      profileInfo.userId = storeData.userId.userId;
    } else {
      profileInfo.relatedDonor = storeData.relatedDonor.relatedDonor;
      profileInfo.userId = storeData.userId.userId;
    }
    profileInfo.ssn = storeData.info.ssn;
    profileInfo.deliveryMethod = storeData.info.deliveryMethod;
    let phones = storeData.phone.phone;
    profileInfo.phones = phones.map(phone => {
      return {
        phoneType: phone.phonetype,
        phoneNumber: phone.phonenumber
      };
    });
    let emails = storeData.email.email;
    profileInfo.emails = emails.map(email => {
      return {
        emailType: email.emailtype,
        emailId: email.emailId
      };
    });
    let addresses = storeData.addresses.addresses;
    addresses.forEach(data => {
      if (data.country === "0") {
        this.props.dropdownValues &&
          this.props.dropdownValues.states &&
          this.props.dropdownValues.states.find(item => {
            if (item.value === data.state || item.desc === data.state) {
              data.state = item.desc;
            }
          });
      }
    });
    const finalAddress = addresses.map(address => {
      let countrydesc = this.props.dropdownValues.countries.find((cntr)=>{
        return  cntr.value === address.country
      })
      return {
        addressId: address.addressId === undefined ? "0" : address.addressId,
        addressType: address.addresstype,
        addressLine1: address.line1,
        addressLine2: address.line2,
        addressLine3: address.line3,
        city: address.city,
        state: address.state,
        zipCode: address.zipcode,
        country: countrydesc?.desc,
        primary: address.primary === true ? "1" : "0"
      };
    })

    const deletedAddress = this.props.primaryDeletedAddressAddress.filter((elm)=>{return !(finalAddress.some((val)=>{
      return val.addressType == elm.addressType
    }))})

    profileInfo.addresses = [...finalAddress,...deletedAddress ]
    

    profileInfo.role = storeData.role.role;
    return profileInfo;
  };

  submitData = () => {
    try {
      let profileData = this.finalProfileData(this.props.primaryAdvisor, true);
      
      const data = {
        method: "POST",
        page: "MyAccountEditAccountAdvisor",
        url: `/DP/Entity/UpdateProfile`,  
        data: profileData,
        isBhoomiUrl:true
      };

      let cb =new Promise((resolve)=>(data.submitDone = resolve));
      if(!this.state.isSubmit)
      {
      this.setState({
        isSubmit:true
      },()=>{
        this.props.analyticsTracking('update2', '', 'UPDATE');
        this.props.submitData(data);
      })
      cb.then(()=>{
        this.setState({isSubmit:false});
      })
    }
    } catch (error) {
      recordError(error);
    }
  };

  renderNextPrimaryButton = (addr, email, phone, radio, advisorType) => {
    let em = "";
    let ph = "";
    let ad = "";
    let dm = "";
    let gend = "";
    let sn = "";
    let confirmSN = "";
    let eq = "";


    let isAddress = true;
    let boolVal = false;
    let infoVal = false;

    if (email) {
      if (this.props.isStep1Edit) {
        em = email;
      } else {
        em = email.email;
      }
    }
    if (addr) {
      if (this.props.isStep1Edit) {
        ad = addr;
      } else {
        ad = addr.addresses;
      }
    }
    if (phone) {
      if (this.props.isStep1Edit) {
        ph = phone;
      } else {
        ph = phone.phone;
      }
    }

    if (radio) {
      dm = radio.deliveryMethod;
      sn = !!radio.ssn;
      confirmSN = !!radio.confirmSSN;
      eq = radio.ssn ? (radio.ssn === radio.confirmSSN ? true : false) : null;
      infoVal = eq && sn && confirmSN;
    }


    if (ad && ad.length > 0) {
      ad.forEach(val => {
        if (isAddress) {
          let zip =
            val.country === "0" ? globalRegex.uszipCode.test(val.zipcode) : globalRegex.nonUSZipCode.test(val.zipcode);
          if (
            val.addresstype &&
            val.addresstype !== "- Select -" &&
            val.line1.trim() &&
            zip &&
            val.zipcode.trim() &&
            val.city.trim() &&
            globalRegex.city.test(val.city) &&
            val.city.length > 1 &&
            val.state.trim() &&
            globalRegex.state.test(val.state) &&
            val.state.length > 1 &&
            val.country &&
            val.country !== "-1"
          ) {
            isAddress = true;
          } else isAddress = false;
        }
      });
    }

    const primaryEmail = this.props.primaryEmail.email && this.props.primaryEmail.email.find(each => each.emailtype === "Primary");
    const isPrimaryEmail = primaryEmail && !!primaryEmail.emailId.trim() ? true : false;

    const primaryPhone = this.props.primaryPhone.phone && this.props.primaryPhone.phone.find(each =>  each.phonetype === "Primary");
    const isprimaryPhone = primaryPhone && !!primaryPhone.phonenumber.trim() ? true : false;

    boolVal =
      isAddress &&
      isPrimaryEmail &&
      isprimaryPhone &&
      dm &&
      dm !== "" &&
      infoVal &&
      this.props.isDataChanged;
    return boolVal;
  };

  closeModal = () => {
    this.setState({
      show: false
    });
  };

  handleExit = () => {
    this.setState({
      show: true,
      type: "exit"
    });
  };

  componentWillUnmount() {
    this.props.clearEditProfileError("");
  }

  disabledReset = type => {
    if (type === "userInfo") {
      this.setState({
        isUserInfo: false
      });
    } else if (type === "phoneInfo") {
      this.setState({
        isPhoneInfo: false
      });
    } else if (type === "emailInfo") {
      this.setState({
        isEmailInfo: false
      });
    } else if (type === "addressInfo") {
      this.setState({
        isAddressInfo: false
      });
    }
  };

  handleExitClick = () => {
    this.props.analyticsTracking("cancel2", "", "Cancel");
    this.setState({
      show: !this.state.show
    });
    history.push("/my-profile");
  };

  getSnapshotBeforeUpdate() {
    const { isSuccess } = this.props;

    if (isSuccess === false) {
      window.scrollTo(0, 0);
    }
  }
  handlePhoneChange = (phone)=>{

      this.props.handlePhoneChange(
        {
          [this.advisorType.toLowerCase()+"Advisor"]: {
           ...phone
          }
        })

    }

  
  handleEmailChange = (email)=>{
    this.props.handleEmailChange(
    {  [this.advisorType.toLowerCase()+"Advisor"]: {
        ...email
       }}
    )
  }

  render() {
    const { isUserInfo, isPhoneInfo, isEmailInfo, isAddressInfo } = this.state;

    let isUpdateEnabled = this.renderNextPrimaryButton(
      this.props.primaryAddress,
      this.props.primaryEmail,
      this.props.primaryPhone,
      this.props.radioInfoPrimary,
      "Primary"
    ); 
    return (
      <div>
        {this.props.isSuccess === false && (
          <div className="advisor-update-error-msg">
            Some of the mandatory information is missing. Please contact us at 888-383-4483.
          </div>
        )}

        <AlertBox
          data-test="ProfileFormAlert"
          show={this.state.show && this.state.type === "reset"}
          field_page="Edit Profile"
          name="Reset Form"
          primaryBtnEvent={() => {
            if (this.props.isStep1Edit) {
              this.handleEditReset();
            } else if (this.advisorType === "Primary") {
              this.handleReset("primaryAdvisor");
            } else {
              this.handleResetSecondary("secondaryAdvisor");
            }
          }}
          secondaryBtnEvent={() => this.closeModal()}
          defaultContent={this.resetPopupContent}
        />

        <AlertBox
          show={this.state.show && this.state.type === "exit"}
          field_page="Edit Profile"
          name="Exit Form"
          primaryBtnEvent={this.handleExitClick.bind(this)}
          secondaryBtnEvent={this.closeModal.bind(this)}
          defaultContent={this.exitPopupContent}
        />

        <AlertBox
          data-test="ProfileFormAlert1"
          show={this.state.show && this.state.type === "remove"}
          field_page="Edit Profile"
          name="Remove Advisor"
          primaryBtnEvent={() => this.props.handleRemoveAdvisor("secondaryAdvisor")}
          secondaryBtnEvent={this.closeModal.bind(this)}
          defaultContent={this.removePopupContent}
        />

        <AdvisoryFormWrapper>
          <FormContainer hideRequiredMark>
            <Form>
              <UserInfoForm
                data-test='UserInfoFormBlock'
                advisorType={this.advisorType}
                enableResetButton={this.enableResetButton}
                userType={this.props.userType}
                isNewSecondaryAdd={isNewSecondaryAdvisor}
                resetErrors={isUserInfo}
                disableReset={type => this.disabledReset(type)}
              />
              <PhoneForm
                data-test='PhoneFormBlock'
                phone  = {this.advisorType === "Primary"?this.props.primaryPhone.phone:this.props.secondaryPhone.phone}
                handleChange={this.handlePhoneChange}
                wrappedComponentRef = {this.phoneFormRef}
                disabled={handleDisabled({...this.props,isNewSecondaryAdvisor})}
              />
              <EmailForm
                data-test='EmailFormBlock'
                email  = {this.advisorType === "Primary"?this.props.primaryEmail.email:this.props.secondaryEmail.email}
                handleChange = {this.handleEmailChange}
                wrappedComponentRef = {this.emailFormRef}
                disabled={handleDisabled({...this.props,isNewSecondaryAdvisor})}
              />
              <AddressForm
                data-test='AddressFormBlock'
                advisorType={this.advisorType}
                enableResetButton={this.enableResetButton}
                userType={this.props.userType}
                isNewSecondaryAdd={isNewSecondaryAdvisor}
                resetErrors={isAddressInfo}
                disableReset={type => this.disabledReset(type)}
                zipCodeData={this.props.zipCodeData.toJS()}
                resetZipCode={(val, field) => this.props.resetZipCode(val, field)}
                resetAllZipCode={val => this.props.resetAllZipCode(val)}
              />
            </Form>

            <RowWrapper>
              <DeliveryMethod
                advisorType={this.advisorType}
                radioInfoPrimary={this.props.radioInfoPrimary}
                radioInfoSecondary={this.props.radioInfoSecondary}
                userType={this.props.userType}
                isNewSecondaryAdd={isNewSecondaryAdvisor}
              />
            </RowWrapper>
            <DividerWrap>
              <Divider />
            </DividerWrap>
            <DisplayFlexSpaceMobile>
              <DisplayFlex>
                <GeneralButton
                  styling="myProfileBtnAlignment"
                  data-test="CancelButton"
                  onClick={this.handleExit}
                  id="btnCancel"
                  text="Cancel"
                  type="functional"
                  inverted={true}
                  width="150px"
                  fontSize="18px"
                  mobWidth="100%"
                  mobMargin="0 15px 15px 0"
                />
                <GeneralButton
                  styling="myProfileBtnAlignment"
                  data-test="ClearButton"
                  onClick={() =>
                    this.setState({
                      show: !this.state.show,
                      type: "reset",
                      reset: true
                    })
                  }
                  disabled={this.geminiUser ? true : false}
                  id="btnClear"
                  text="Clear"
                  type="functional"
                  inverted={true}
                  width="150px"
                  fontSize="18px"
                  mobWidth="100%"
                  mobMargin="0 0 10px 0"
                />
              </DisplayFlex>
              <GeneralButton
                styling="myProfileBtnAlignment"
                onClick={this.submitData}
                id="btnSubmit"
                data-test="updateButton"
                disabled={(!this.state.isSubmit)&&(this.geminiUser || !isUpdateEnabled)}
                text={this.state.isSubmit?<Spinner/>:"Update"}  
                type="functional"
                inverted={false}
                width="150px"
                fontSize="18px"
                mobWidth="100%"
                mobMargin="0 0 10px 0"
              />
            </DisplayFlexSpaceMobile>
          </FormContainer>
        </AdvisoryFormWrapper>
      </div>
    );
  }
}



const primaryAddressShape = PropTypes.shape({
  addresses: PropTypes.arrayOf(
    PropTypes.shape({
      addressId: PropTypes.number,
      addressUpdated: PropTypes.bool,
      addresstype: PropTypes.string,
      city: PropTypes.string,
      country: PropTypes.string,
      key: PropTypes.number,
      line1: PropTypes.string,
      line2: PropTypes.string,
      line3: PropTypes.string,
      primary: PropTypes.bool,
      state: PropTypes.string,
      zipcode: PropTypes.string
    })
  )
});

const emailShape = PropTypes.shape({
  email: PropTypes.arrayOf(
    PropTypes.shape({
      addressId: PropTypes.number,
      emailId: PropTypes.string,
      emailtype: PropTypes.string,
      key: PropTypes.number,
      primary: PropTypes.bool
    })
  )
});

const infoShape = PropTypes.shape({
  confirmSSN: PropTypes.string,
  deliveryMethod: PropTypes.string,
  dob: PropTypes.string,
  firstname: PropTypes.string,
  gender: PropTypes.string,
  lastname: PropTypes.string,
  middlename: PropTypes.any,
  ssn: PropTypes.string,
  suffix: PropTypes.string,
  title: PropTypes.string
});

const phoneShape = PropTypes.shape({
  phone: PropTypes.arrayOf(
    PropTypes.shape({
      addressId: PropTypes.number,
      key: PropTypes.number,
      phonenumber: PropTypes.string,
      phonetype: PropTypes.string,
      primary: PropTypes.bool
    })
  )
});

ProfileForm.propTypes = {
  accountName: PropTypes.any,
  analyticsTracking: PropTypes.func,
  clearEditProfileError: PropTypes.func,

  dropdownValues: PropTypes.shape({
    states: PropTypes.array
  }),

  handleRemoveAdvisor: PropTypes.func,
  handleResetFormAddress: PropTypes.func,
  handleResetFormEmail: PropTypes.func,
  handleResetFormInfo: PropTypes.func,
  handleResetFormPhone: PropTypes.func,
  isDataChanged: PropTypes.bool,
  isStep1Edit: PropTypes.any,
  isSuccess: PropTypes.bool,
  jsonTemp: PropTypes.func,
  primaryAddress: primaryAddressShape,

  primaryAdvisor: PropTypes.shape({
    addresses: PropTypes.shape({
      addresses: primaryAddressShape
    }),

    email: emailShape,

    info: infoShape,

    phone: phoneShape,

    relatedDonor: PropTypes.shape({
      relatedDonor: PropTypes.arrayOf(PropTypes.any)
    })
  }),

  primaryEmail: emailShape,

  primaryPhone: phoneShape,

  radioInfoPrimary: infoShape,
  radioInfoSecondary: PropTypes.any,
  reset: PropTypes.func,
  resetAllZipCode: PropTypes.func,
  resetZipCode: PropTypes.func,
  submitData: PropTypes.func,
  userType: PropTypes.string,
  webAccessInfo: PropTypes.shape({
    fundName: PropTypes.string,
    userId: PropTypes.any
  }),

  zipCodeData: PropTypes.shape({
    toJS: PropTypes.func
  })
};

const WrappedProfileForm = Form.create({ name: "advisor" })(ProfileForm);

const mapStateToProps = state => ({
  primaryEmail: state.getIn(["myAccount", "primaryAdvisor", "email"]),
  secondaryPhone: state.getIn(["myAccount", "secondaryAdvisor", "phone"]),
  secondaryEmail:state.getIn(["myAccount", "secondaryAdvisor", "email"]),
  primaryPhone: state.getIn(["myAccount", "primaryAdvisor", "phone"]),
  primaryAddress: state.getIn(["myAccount", "primaryAdvisor", "addresses"]),
  primaryDeletedAddressAddress: state.getIn(["myAccount", "primaryAdvisor","deletedAddress"]),
  webAccessInfo: state.getIn(["myAccount", "webAccessInfo"]).toJS(),
  primaryAdvisor: state.getIn(["myAccount", "primaryAdvisor"]).toJS(),
  radioInfoPrimary: state.getIn(["myAccount", "primaryAdvisor", "info"]),
  disable: state.getIn(["myAccount", "primaryAdvisor", "disable"]),
  activePageStepNumber: state.getIn(["globalState", "activePageStepNumber"]),
  stepperConfig: state.getIn(["globalState", "stepperConfig"]),
  isStep1Edit: state.getIn(["myAccount", "isStep1Edit", "isStep1Edit", "isStep1Edit"]),
  tempData: state.getIn(["myAccount", "tempJSON", "tempJSON"]),
  isDataChanged: state.getIn(["myAccount", "isDataChanged", "changed"]),
  isSuccess: state.getIn(["myAccount", "postSuccess"]),
  zipCodeData: state.getIn(["zipCode", "zipCodes"]),
  dropdownValues: state.getIn(["myAccount", "dropdownValues", "data"])
});

export const mapDispatchToProps = dispatch => {
  return {
    handleResetFormAddress: arr => dispatch(handleResetFormAddress(arr)),
    handleResetFormPhone: arr => dispatch(handleResetFormPhone(arr)),
    handleResetFormEmail: arr => dispatch(handleResetFormEmail(arr)),
    handleResetFormInfo: arr => dispatch(handleResetFormInfo(arr)),
    reset: val => dispatch(reset(val)),
    disableButton: val => dispatch(disableButton(val)),
    finishActivePageStep: () => dispatch(updatePageStepToFinish()),
    step1Edit: val => dispatch(step1Edit(val)),
    jsonTemp: val => dispatch(jsonTemp(val)),
    submitData: data => dispatch(postProfile(data)),
    clearEditProfileError: data => dispatch(clearEditProfileError(data)),
    resetZipCode: (val, field) => dispatch(resetZipCode(val, field)),
    resetAllZipCode: val => dispatch(resetAllZipFields(val)),
    flushZipCode: () => dispatch(flushZipCode()),
    handleEmailChange: arr => dispatch(onEmailChangeHandler(arr)),
    handlePhoneChange: arr => dispatch(onPhoneChangeHandler(arr))
    
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WrappedProfileForm);
